"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.password = exports.username = exports.email = exports.iso8601Datestring = exports.uidv4 = undefined;

var _joi = require("joi");

var Joi = _interopRequireWildcard(_joi);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var uidv4 = exports.uidv4 = Joi.string().guid().required().label("uidv4").description("uidv4 (type)").example("0102cad9-f620-4fd0-bb05-0e1a91784213");
var iso8601Datestring = exports.iso8601Datestring = Joi.date().iso().required().label("iso8601Datestring").description("iso8601Datestring (type)").example("2015-11-29T08:00:00.000Z");
var email = exports.email = Joi.string().allow(null).trim().lowercase().max(255).email().label("email").description("email (type): trimed and pattern matched for email, Max 255 long").example("team@allaboutapps.at"); // attention, this might be negative in the future, therefore no range constraints are applied.
// inline username and password string validations
var username = exports.username = Joi.string().regex(/^[0-9a-zA-Z_.\-\+@]+$/).trim().options({ convert: false }).example("testuser1"); // important, do not convert!
var password = exports.password = Joi.string().trim().min(6).options({ convert: false }).example("testpassword1"); // important, do not convert!


/*****************
 ** WEBPACK FOOTER
 ** ../backend/src/shared/schemas/types.ts
 ** module id = 220
 ** module chunks = 0
 **/